const state = () => ({
    to: '',
    from: '',
    next: '',
    isThemeAja: false,
})

const getters = {
    getToRoute: state => () => state.to,
    getFromRoute: state => () => state.from,
    getNextRoute: state => () => state.next,
    isThemeAja: state => state.isThemeAja,
}

const actions = {
    setThemeAja: ({ commit }, value) => {
        if (value) {
            localStorage.setItem('theme.dark', true)
        }
        commit('setThemeAja', value)
    }
}


const mutations = {
    setToRoute (state, to) { state.to = to },
    setFromRoute (state, from) { state.from = from },
    setNextRoute (state, next) { state.next = next },
    setThemeAja (state, value) { state.isThemeAja = value },
}

export default {
    state,
    getters,
    actions,
    mutations,
}